function getBoardScrollPaddingStart(scrollContainer: HTMLElement): number {
  const styles = getComputedStyle(scrollContainer);
  const scrollPadding = parseFloat(styles.scrollPaddingInlineStart);
  if (!Number.isNaN(scrollPadding) && scrollPadding > 0) {
    return scrollPadding;
  }
  const padding = parseFloat(styles.paddingInlineStart);
  return Number.isNaN(padding) ? 0 : padding;
}

export function scrollBoardColumnFullyIntoView(
  scrollContainer: HTMLElement,
  column: HTMLElement,
) {
  const containerRect = scrollContainer.getBoundingClientRect();
  const columnRect = column.getBoundingClientRect();
  const paddingStart = getBoardScrollPaddingStart(scrollContainer);
  let scrollDelta = 0;

  if (columnRect.left < containerRect.left + paddingStart) {
    scrollDelta = columnRect.left - (containerRect.left + paddingStart);
  } else if (columnRect.right > containerRect.right) {
    scrollDelta = columnRect.right - containerRect.right;
  }

  if (scrollDelta !== 0) {
    scrollContainer.scrollBy({ left: scrollDelta, behavior: 'smooth' });
  }
}

export function scrollBoardColumnToStart(
  scrollContainer: HTMLElement,
  column: HTMLElement,
) {
  const containerRect = scrollContainer.getBoundingClientRect();
  const columnRect = column.getBoundingClientRect();
  const paddingStart = getBoardScrollPaddingStart(scrollContainer);
  const scrollDelta = columnRect.left - (containerRect.left + paddingStart);

  if (scrollDelta !== 0) {
    scrollContainer.scrollBy({ left: scrollDelta, behavior: 'smooth' });
  }
}

function getVerticalScrollContainer(
  fromElement: HTMLElement,
): HTMLElement | null {
  const ionContent = fromElement.closest('ion-content');
  if (ionContent?.shadowRoot) {
    const innerScroll =
      ionContent.shadowRoot.querySelector<HTMLElement>('.inner-scroll');
    if (innerScroll) return innerScroll;
  }
  return (document.scrollingElement as HTMLElement | null) ?? document.body;
}

export function scrollDroppedLeadCardIntoView(
  cardEl: HTMLElement,
  boardScrollContainer: HTMLElement,
  options: { isDesktop: boolean },
) {
  const columnEl = cardEl.closest<HTMLElement>('[data-column-id]');
  if (columnEl) {
    if (options.isDesktop) {
      scrollBoardColumnFullyIntoView(boardScrollContainer, columnEl);
    } else {
      scrollBoardColumnToStart(boardScrollContainer, columnEl);
    }
  }

  const scrollContainer = getVerticalScrollContainer(cardEl);
  if (!scrollContainer) return;

  const cardRect = cardEl.getBoundingClientRect();
  const containerRect = scrollContainer.getBoundingClientRect();
  const cardCenter = cardRect.top + cardRect.height / 2;
  const containerCenter = containerRect.top + containerRect.height / 2;
  let targetScrollTop =
    scrollContainer.scrollTop + (cardCenter - containerCenter);

  const maxScrollTop = Math.max(
    0,
    scrollContainer.scrollHeight - scrollContainer.clientHeight,
  );
  targetScrollTop = Math.max(0, Math.min(maxScrollTop, targetScrollTop));

  const ionContent = cardEl.closest('ion-content') as
    | (HTMLElement & {
        scrollToPoint?: (
          x: number,
          y: number,
          duration: number,
        ) => Promise<void>;
      })
    | null;

  if (ionContent?.scrollToPoint) {
    void ionContent.scrollToPoint(0, targetScrollTop, 300);
    return;
  }

  scrollContainer.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
}
